import store from "../store/index";

const SELECTORS = {
  btn: ".js-accordion-btn",
  body: ".js-accordion-content",
  icon: ".js-accordion-icon",
};

const CLASSES = {
  hidden: "hidden",
  active: "active",
};

class Accordion {
  constructor(context) {
    this.context = context;
  }

  init() {
    this.accordionBtn = this.context.querySelector(SELECTORS.btn);
    this.accordionBody = this.context.querySelector(SELECTORS.body);
    this.accordionIcon = this.context.querySelector(SELECTORS.icon);

    this.subscribe();
  }

  dispatchHeight(accordionHeight) {
    store.dispatch("setAccordionHeight", { accordionHeight });
  }

  subscribe() {
    if (this.accordionBtn !== null) {
      this.accordionBtn.addEventListener("click", (event) => {
        this.dispatchHeight(-this.context.offsetHeight);
        this.toggleAccordion();
      });
    }

    window.addEventListener("load", (event) => {
      this.dispatchHeight(this.context.offsetHeight);
    });
  }

  toggleAccordion() {
    this.accordionBody.classList.toggle(CLASSES.hidden);
    this.accordionIcon.classList.toggle(CLASSES.active);
    let expanded = true;
    if (this.accordionBtn.getAttribute("aria-expanded") === "true") {
      expanded = false;
    }
    this.accordionBtn.setAttribute("aria-expanded", expanded);

    return this;
  }
}

export { Accordion };
